import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface LoanOffer {
    loanProviderImage: string;
    loanAmount: string; // Formatted string, e.g. "₹15,000"
    apr: string;       // Formatted string, e.g. "12.66% p.a."
    loanTerm: string;  // Formatted string, e.g. "36 Months"
    monthlyPayment: string; // Formatted string, e.g. "₹449.50"
    offerLink?: string; // Optional link to the offer
}

@Component({
    selector: 'app-loan-offer-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loan-offer-card.html',
    styleUrl: './loan-offer-card.scss',
})
export class LoanOfferCardComponent {
    @Input() offer: LoanOffer = {
        loanProviderImage: 'https://placehold.co/116x32',
        loanAmount: '₹15,000',
        apr: '12.66%',
        loanTerm: '36 Months',
        monthlyPayment: '₹449.50'
    };

    @Output() selectLoan = new EventEmitter<void>();

    onSelectClick(): void {
        this.selectLoan.emit();
    }
}
